export const SET_PANEL = 'SET_PANEL';
export const SET_MENU = 'SET_MENU';
export const SET_PAGE = 'SET_PAGE';